var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"c_table_wrap"},[_vm._v(" 큐레이터 디테일 레이아웃 "),_c('div',[_c('button',{on:{"click":function($event){return _vm.$router.back()}}},[_vm._v("목록")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }